import React, { Fragment, useState } from 'react'
import { Waypoint } from 'react-waypoint'
import classNames from 'classnames'
import './Carousel.scss'

const CarouselControls = props => {
  const [isViewable, toggleViewable] = useState(false)
  const triangleControls = (
    <Waypoint onEnter={() => toggleViewable(true)} bottomOffset="20%">
      <div
        className={classNames('col-sm-4 featured-cat-no-mobile', {
          'carousel-control-animate': isViewable,
          'animate-hidden': !isViewable,
        })}
        id="carousel-triangle-arrows"
      >
        <div
          className={`featured-cat-arrow-left mdi ${
            props.currentSlide === 0 ? 'mdi-triangle-outline' : 'mdi-triangle'
          } `}
          onClick={props.prev}
        />
        <div
          className={`featured-cat-arrow-right mdi ${
            props.currentSlide + 1 === props.totalSlides ? 'mdi-triangle-outline' : 'mdi-triangle'
          } `}
          onClick={props.next}
        />
      </div>
    </Waypoint>
  )

  const classicControls = (
    <Fragment>
      <div className="carousel-control-prev">
        <span className="carousel-control-prev-icon" aria-hidden="true" onClick={props.prev} />
        <span className="sr-only">Previous</span>
      </div>
      <div className="carousel-control-next">
        <span className="carousel-control-next-icon" aria-hidden="true" onClick={props.next} />
        <span className="sr-only">Next</span>
      </div>
    </Fragment>
  )

  const controls = props.type === 'triangle' ? triangleControls : classicControls

  return <Fragment>{controls}</Fragment>
}

export default CarouselControls
